import { useTranslation, I18nextProvider } from 'react-i18next';
import i18n from '../config/i18n';

export const LocaleProvider = ({ children }) => {
    return (
        <I18nextProvider i18n={i18n}>
            {children}
        </I18nextProvider>
    )
}

export const useLocale = () => useTranslation();
